import React, {createContext, useState} from 'react';
const ContextApi = createContext({});

export default ContextApi;

export const ContextProvider = ({ children }) => {
	const [accountManagerReportData, setAccountManagerReportData] = useState(null);
	const [header, setHeader] = useState(null);

	return (
		<>
			<ContextApi.Provider
				value={{
					accountManagerReportData,
					setAccountManagerReportData,
					header,
					setHeader
				}}
			>
				{children}
			</ContextApi.Provider>
		</>
	);
};